export default "__VITE_ASSET__Cb4YAe86__"